import React from 'react';
import { TextField } from '@rmwc/textfield';
import { Checkbox } from '@rmwc/checkbox';
import { connect } from 'react-redux';
import { Radio } from '@rmwc/radio';
import * as actionCreator from "../../action/extra_options/orderExtras.action.js";
import * as validate from '../Modals/validations';
import EditPriceItem from '../EditPriceItem/EditPriceItem.js';
import EngineeringDrawing from './EngineeringDrawing.js';
import ReadMore from '../ReadMore';
import AnimButton from '../Button/AnimButton.js';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const OrderExtras = (props) => {
   const capitalizeFirstLetter = (string) => {
      if (string == undefined || string.length === 0) {
         return string;
      }
      return string.charAt(0).toUpperCase() + string.slice(1);
   };

   const chkgrvy_value = props.const_var.post_data.building != undefined ? props.const_var.post_data.building.order_extra_items.has_grvy : 0;
   const IsQuoteOrder = props.const_var.post_data.building != undefined ? props.const_var.crmSetting.is_module_name : "";

   let style;
   if (window.screen.availWidth > 1024) {
      style = { 'height': 'auto !important' };
   }

   const isUserData = localStorage.getItem('userData') ? true : false;
   const checkNatCarport = props.params.m_s_n == 184;

   return (
      <>
         <form id="configuration" name="configuration">
            <div className="section-seprator">
               <div className='card-body-inner'>
                  <div className='form-group mb-0'>
                     <div className="floating-label-input">
                        {props.ExtrascrmSetting.is_module_name != "inventory" ?
                           <TextField
                              placeholder='Start Typing…'
                              onFocus="this.placeholder=''"
                              textarea
                              value={props.order_extra_items.additional_note}
                              fullwidth
                              rows={2}
                              maxLength={1000}
                              onChange={e => props.orderExtrasChangeValue(e, 'additional_note', 'no')}
                              characterCount
                              helpText={{ persistent: true }}
                           /> :
                           <TextField
                              textarea
                              value={props.order_extra_items.description}
                              fullwidth
                              placeholder="Description"
                              rows={2}
                              maxLength={2000}
                              onChange={e => props.orderExtrasChangeValue(e, 'description', 'no')}
                              characterCount
                              helpText={{ persistent: true }}
                           />
                        }
                     </div>
                  </div>

                  {props.ExtrascrmSetting.is_module_name != "inventory" ?
                     <>
                        <div className='form-group'>
                           <div className='row'>
                              <div className='col'>
                                 <label className="control-label-text">Job Site Level</label>
                              </div>
                              <div className='col-auto text-right'>
                                 <div className='toggle-group'>
                                    <div class={props.order_extra_items.surface_level == "yes" ? "toggle-switches active" : "toggle-switches"}>
                                       <span className='toggle-label-control'>{props.order_extra_items.surface_level == "yes" ? "Yes" : "No"}</span>
                                       <input
                                          id="jobSite"
                                          name="Job Site Level"
                                          type="checkbox"
                                          value={props.order_extra_items.surface_level}
                                          checked={props.order_extra_items.surface_level == "yes" ? true : false}
                                          onChange={e => props.orderExtrasChangeValue(e, 'surface_level', 'no')}
                                       />
                                       <label for="jobSite"></label>
                                    </div>
                                 </div>
                              </div>
                           </div>

                           <div className='row'>
                              <div className='col'>
                                 <label className="control-label-text">Inside City Limit</label>
                              </div>
                              <div className='col-auto text-right'>
                                 <div className='toggle-group'>
                                    <div class={props.order_extra_items.inside_city == "yes" ? "toggle-switches active" : "toggle-switches"}>
                                       <span className='toggle-label-control'>{props.order_extra_items.inside_city == "yes" ? "Yes" : "No"}</span>
                                       <input
                                          id="insideCity"
                                          name="Inside City Limit"
                                          type="checkbox"
                                          value={props.order_extra_items.inside_city}
                                          checked={props.order_extra_items.inside_city == "yes" ? true : false}
                                          onChange={e => props.orderExtrasChangeValue(e, 'inside_city', 'no')}
                                       />
                                       <label for="insideCity"></label>
                                    </div>
                                 </div>
                              </div>
                           </div>

                           <div className='row'>
                              <div className='col'>
                                 <label className="control-label-text">Installation Ready</label>
                              </div>
                              <div className='col-auto text-right'>
                                 <div className='toggle-group'>
                                    <div class={props.order_extra_items.installation_ready == "yes" ? "toggle-switches active" : "toggle-switches"}>
                                       <span className='toggle-label-control'>{props.order_extra_items.installation_ready == "yes" ? "Yes" : "No"}</span>
                                       <input
                                          id="installReady"
                                          name="Installation Ready"
                                          type="checkbox"
                                          value={props.order_extra_items.installation_ready}
                                          checked={props.order_extra_items.installation_ready == "yes" ? true : false}
                                          onChange={e => props.orderExtrasChangeValue(e, 'installation_ready', 'no')}
                                       />
                                       <label for="installReady"></label>
                                    </div>
                                 </div>
                              </div>
                           </div>

                           {<div className='row'>
                              <div className='col'>
                                 <label className="control-label-text">Electricity Available</label>
                              </div>
                              <div className='col-auto text-right'>
                                 <div className='toggle-group'>
                                    <div class={props.order_extra_items.electricity == "yes" ? "toggle-switches active" : "toggle-switches"}>
                                       <span className='toggle-label-control'>{props.order_extra_items.electricity == "yes" ? "Yes" : "No"}</span>
                                       <input
                                          id="electricity"
                                          name="Electricity"
                                          type="checkbox"
                                          value={props.order_extra_items.electricity}
                                          checked={props.order_extra_items.electricity == "yes" ? true : false}
                                          onChange={e => props.orderExtrasChangeValue(e, 'electricity', 'no')}
                                       />
                                       <label for="electricity"></label>
                                    </div>
                                 </div>
                              </div>
                           </div>}

                           {props.params.m_s_n != 169 &&
                              <div className='row'>
                                 <div className='col'>
                                    <label className="control-label-text">Welded Spacer</label>
                                 </div>
                                 <div className='col-auto text-right'>
                                    <div className='toggle-group'>
                                       <div class={props.order_extra_items.welded_spacer == "yes" ? "toggle-switches active" : "toggle-switches"}>
                                          <span className='toggle-label-control'>{props.order_extra_items.welded_spacer == "yes" ? "Yes" : "No"}</span>
                                          <input
                                             id="WeldedSpacer"
                                             name="welded_spacer"
                                             type="checkbox"
                                             value={props.order_extra_items.welded_spacer}
                                             checked={props.order_extra_items.welded_spacer == "yes" ? true : false}
                                             onChange={e => props.orderExtrasChangeValue(e, 'welded_spacer', 'no')}
                                          />
                                          <label for="WeldedSpacer"></label>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           }

                           <div className='row'>
                              <div className='col'>
                                 <label className="control-label-text">Notched Lip</label>
                              </div>
                              <div className='col-auto text-right'>
                                 <div className='toggle-group'>
                                    <div class={props.order_extra_items.notched_lip == "yes" ? "toggle-switches active" : "toggle-switches"}>
                                       <span className='toggle-label-control'>{props.order_extra_items.notched_lip == "yes" ? "Yes" : "No"}</span>
                                       <input
                                          id="notched_lip"
                                          name="notched_lip"
                                          type="checkbox"
                                          value={props.order_extra_items.notched_lip}
                                          checked={props.order_extra_items.notched_lip == "yes" ? true : false}
                                          onChange={e => props.orderExtrasChangeValue(e, 'notched_lip', 'no')}
                                       />
                                       <label for="notched_lip"></label>
                                    </div>
                                 </div>
                              </div>
                           </div>

                           <div className='row'>
                              <div className='col'>
                                 <label className="control-label-text">5ft. Space Around the Building</label>
                              </div>
                              <div className='col-auto text-right'>
                                 <div className='toggle-group'>
                                    <div class={props.order_extra_items.space_around_building == "yes" ? "toggle-switches active" : "toggle-switches"}>
                                       <span className='toggle-label-control'>{props.order_extra_items.space_around_building == "yes" ? "Yes" : "No"}</span>
                                       <input
                                          id="space_around_building"
                                          name="space_around_building"
                                          type="checkbox"
                                          value={props.order_extra_items.space_around_building}
                                          checked={props.order_extra_items.space_around_building == "yes" ? true : false}
                                          onChange={e => props.orderExtrasChangeValue(e, 'space_around_building', 'no')}
                                       />
                                       <label for="space_around_building"></label>
                                    </div>
                                 </div>
                              </div>
                           </div>

                           <div className='row'>
                              <div className='col'>
                                 <label className="control-label-text">Site Clear of Obstacles</label>
                              </div>
                              <div className='col-auto text-right'>
                                 <div className='toggle-group'>
                                    <div class={props.order_extra_items.site_clear_obstacle == "yes" ? "toggle-switches active" : "toggle-switches"}>
                                       <span className='toggle-label-control'>{props.order_extra_items.site_clear_obstacle == "yes" ? "Yes" : "No"}</span>
                                       <input
                                          id="site_clear_obstacle"
                                          name="site_clear_obstacle"
                                          type="checkbox"
                                          value={props.order_extra_items.site_clear_obstacle}
                                          checked={props.order_extra_items.site_clear_obstacle == "yes" ? true : false}
                                          onChange={e => props.orderExtrasChangeValue(e, 'site_clear_obstacle', 'no')}
                                       />
                                       <label for="site_clear_obstacle"></label>
                                    </div>
                                 </div>
                              </div>
                           </div>

                           <div className='row'>
                              <div className='col'>
                                 <label className="control-label-text">Price Breakdown in PDF</label>
                              </div>
                              <div className='col-auto text-right'>
                                 <div className='toggle-group'>
                                    <div class={props.order_extra_items.pdf_price_breakdown == '1' ? "toggle-switches active" : "toggle-switches"}>
                                       <span className='toggle-label-control'>{props.order_extra_items.pdf_price_breakdown == '1' ? "Yes" : "No"}</span>
                                       <input
                                          id="priceBreakdown"
                                          name="Price Breakdown in PDF"
                                          type="checkbox"
                                          value={props.order_extra_items.pdf_price_breakdown}
                                          checked={props.order_extra_items.pdf_price_breakdown == "1" ? true : false}
                                          onChange={e => props.orderExtrasChangeValue(e, 'pdf_price_breakdown', 'no')}
                                       />
                                       <label for="priceBreakdown"></label>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div className='form-group'>
                           <label className="control-label">Permit Required</label>
                           <div className='radio-group'>
                              <Radio
                                 label="Yes"
                                 value="yes"
                                 checked={props.order_extra_items.permit == "yes" ? true : false}
                                 name="permit"
                                 onChange={e => props.orderExtrasChangeValue(e, 'permit', 'no')}
                              />
                              {(props.params.p_s_n == 29 && (props.params.m_s_n == 3 || props.params.m_s_n == 9)) && props.order_extra_items.permit == "yes" ? null :
                                 props.order_extra_items.permit == "yes" ?
                                    <div className="price-box">
                                       <EditPriceItem jsonObj={props.order_extra_items.order_permit_fee} jsonObjKey="order_permit_fee" />
                                    </div> : null
                              }
                           </div>
                           <div className='radio-group'>
                              <Radio
                                 label="No"
                                 value="no"
                                 name="permit"
                                 checked={props.order_extra_items.permit == "no" ? true : false}
                                 onChange={e => props.orderExtrasChangeValue(e, 'permit', 'no')}
                              />
                           </div>
                           <div className='radio-group'>
                              <Radio
                                 label="Customer to Verify"
                                 value="cust_verify"
                                 name="permit"
                                 className='w-full'
                                 checked={props.order_extra_items.permit == "cust_verify" ? true : false}
                                 onChange={e => props.orderExtrasChangeValue(e, 'permit', 'no')}
                              />
                           </div>
                        </div>
                     </>
                     : null}

                  {props.const_var.isMultiSelectDrawingOpt == true &&
                     isUserData == true &&
                     props.const_var.c_m_a[props.params.p_b_t] != undefined &&
                     props.const_var.c_m_a[props.params.p_b_t].drawings != undefined &&
                     props.const_var.c_m_a[props.params.p_b_t].drawings.length > 0 &&
                     <EngineeringDrawing />
                  }

                  <div className='form-group'>
                     <div className='row'>
                        <div className='col'>
                           <div className='control-label-bar'>
                              <label className='control-label-text'>Gravy </label>
                              <div class='control-label-action'>
                                 <div className={(chkgrvy_value != undefined && chkgrvy_value == 1) ? 'price-box disabled' : 'price-box'}>
                                    <EditPriceItem is_disabled={(chkgrvy_value != undefined && chkgrvy_value == 1) ? "true" : "false"} jsonObj={props.order_extra_items.grvy_value} jsonObjKey="grvy_value" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col'>
                           <div className='control-label-bar'>
                              <label className='control-label-text'>Equipment Rental </label>
                              <div className='control-label-action'>
                                 <div className='price-box'>
                                    <EditPriceItem jsonObj={props.order_extra_items.equipment_rental} jsonObjKey="equipment_rental" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col'>
                           <div className='control-label-bar'>
                              <label className='control-label-text'>Document Fee </label>
                              <div className='control-label-action'>
                                 <div className='price-box'>
                                    <EditPriceItem jsonObj={props.order_extra_items.document_fee} jsonObjKey="document_fee" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col'>
                           <div className='control-label-bar'>
                              <label className='control-label-text'>Concrete Work </label>
                              <div className='control-label-action'>
                                 <div className='price-box'>
                                    <EditPriceItem jsonObj={props.order_extra_items.concrete_work} jsonObjKey="concrete_work" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col'>
                           <div className='control-label-bar'>
                              <label className='control-label-text'>Ground Work </label>
                              <div className='control-label-action'>
                                 <div className='price-box'>
                                    <EditPriceItem jsonObj={props.order_extra_items.ground_work} jsonObjKey="ground_work" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col'>
                           <div className='control-label-bar'>
                              <label className='control-label-text'>Processing Fee </label>
                              <div className='control-label-action'>
                                 <div className='price-box'>
                                    <EditPriceItem jsonObj={props.order_extra_items.order_processing_fee} jsonObjKey="order_processing_fee" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col'>
                           <div className='control-label-bar'>
                              <label className='control-label-text'>Delivery Fee </label>
                              <div className='control-label-action'>
                                 <div className='price-box'>
                                    <EditPriceItem jsonObj={props.order_extra_items.delivery_fee} jsonObjKey="delivery_fee" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col'>
                           <div className='control-label-bar'>
                              <label className='control-label-text'>Freight Fee </label>
                              <div className='control-label-action'>
                                 <div className='price-box'>
                                    <EditPriceItem jsonObj={props.order_extra_items.freight} jsonObjKey="freight" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col'>
                           <div className='control-label-bar'>
                              <label className='control-label-text'>Labor Fee </label>
                              <div className='control-label-action'>
                                 <div className='price-box'>
                                    <EditPriceItem jsonObj={props.order_extra_items.extra_labour} jsonObjKey="extra_labour" />
                                 </div>
                              </div>
                              <OverlayTrigger
                                 trigger="hover"
                                 placement={'bottom'}
                                 rootClose={true}
                                 overlay={(
                                    <Popover className="labor-info-popover popover-info popover-md">
                                       <Popover.Content>
                                          <div className='info-content'>
                                             <p>The <strong>"Labor Fee"</strong> can be a fixed amount or a percentage of the Building Amount/Subtotal, as per the manufacturer.</p>
                                          </div>
                                       </Popover.Content>
                                    </Popover>
                                 )}>
                                 <span className='d-flex align-items-center cursor-pointer' style={{ position: 'absolute', right: '10px', marginLeft: '10px' }}><i class="icon-info"></i></span>
                              </OverlayTrigger>
                           </div>
                        </div>
                     </div>
                     {/* this.props.const_var.isMultiSelectDrawingOpt == true && 
                        this.props.const_var.c_m_a[this.props.params.p_b_t] != undefined && this.props.const_var.c_m_a[this.props.params.p_b_t].drawings != undefined &&  this.props.const_var.c_m_a[this.props.params.p_b_t].drawings.length != 0 */
                        <div className='row'>
                           <div className='col'>
                              <div className='control-label-bar'>
                                 <span className='icon icon-arrow-line-ico'></span>
                                 <label className='control-label-text'>CC Processing Fee</label>
                                 <div className='control-label-action'>
                                    <div className='price-box'>
                                       <EditPriceItem jsonObj={props.order_extra_items.processing_fee} jsonObjKey="processing_fee" />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     }
                     {props.ExtrascrmSetting.is_module_name != "inventory" ?
                        <>
                           <div className='row'>
                              <div className='col-auto'>
                                 <div className='radio-group'>
                                    <Radio
                                       label="Include in Order"
                                       value="1"
                                       className='w-full'
                                       name="dont_show_processing_fee_pdf"
                                       checked={props.order_extra_items.dont_show_processing_fee_pdf == 1 ? true : false}
                                       onChange={e => props.orderExtrasChangeValue(e, 'dont_show_processing_fee_pdf', 'Include CC Fee in Order')}
                                    />
                                 </div>
                              </div>
                              <div className='col-auto'>
                                 <div className='radio-group'>
                                    <Radio
                                       label="Include in Invoice only"
                                       value="2"
                                       className='w-full'
                                       checked={props.order_extra_items.dont_show_processing_fee_pdf == 2 ? true : false}
                                       onChange={e => props.orderExtrasChangeValue(e, 'dont_show_processing_fee_pdf', 'Include CC Fee in Invoice only')}
                                       name="dont_show_processing_fee_pdf"
                                    />
                                 </div>
                              </div>
                           </div>
                        </>
                        : null}
                  </div>
               </div>

               <div className='card-footer-inner'>
                  <div className={props.const_var.additionalChargeArr != undefined && props.const_var.additionalChargeArr.length > 0 ? 'add-action d-none' : 'add-action'}>
                     <a className="btn btn-link btn-sm p-0" onClick={(e) => { props.addAdditionalCharge("add", e); }}>+ Add Additional Charges</a>
                  </div>
                  {props.const_var.additionalChargeArr != undefined && props.const_var.additionalChargeArr.length > 0 ?
                     <div className='add-box'>
                        {props.const_var.additionalChargeArr.length > 0 && props.const_var.additionalChargeArr.map((data, index) => {
                           return (
                              <div className='add-item-box' key={index}>
                                 <div class='form-group-sm'>
                                    <div class='control-label-bar justify-content-start'>
                                       <label class='control-label'>Additional Charges {index + 1}</label>
                                       <div class='control-label-action'>
                                          <div className='edit-price'>
                                             <input
                                                type='text'
                                                className='form-control'
                                                maxLength="6"
                                                onChange={e => props.orderExtrasChangeValue(e, 'order_extra_additionalCharges', 'no', index)}
                                                value={data.price}
                                                onKeyUp={e => validate.numericCheckwithDecimalVal(e)}
                                                name="order_extra_additionalCharges"
                                             />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="floating-label-input">
                                       <TextField
                                          placeholder="Name"
                                          value={data.name}
                                          onChange={(e) => props.addAdditionalCharge("name", e.target.value, index)}
                                          maxLength={35}
                                       />
                                    </div>
                                 </div>
                                 <div className='form-group d-none'>
                                    <div className='form-inline-group form-inline-md'>
                                       <div className='form-item-inline'>
                                          <div className='check-group'>
                                             <Checkbox
                                                label="Taxable & Commissionable"
                                                value={data.taxable}
                                                checked={data.taxable}
                                                onChange={(e) => props.addAdditionalCharge("taxable", !data.taxable, index)}
                                             />
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className='add-control'>
                                    {index == props.const_var.additionalChargeArr.length - 1 ?
                                       <button className="btn btn-primary-link btn-sm p-0" onClick={e => props.addAdditionalCharge("add", e)}>+ Add more</button>
                                       : null}
                                    <button type="button" className="btn btn-default-link btn-sm p-0" onClick={e => props.addAdditionalCharge("delete", e, index)}>— Remove</button>
                                 </div>
                              </div>
                           );
                        })}
                     </div>
                     : null}
               </div>

               <div className='read-box d-none'>
                  <ReadMore>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</ReadMore>
               </div>
            </div>
         </form>
      </>
   );
};

const mapStateToProps = (state) => {
   return { ...state.reducer, ...state.orderExtrasReducer };
};

export default connect(mapStateToProps, actionCreator)(OrderExtras);